import { createPortal } from "react-dom";

export default function Modal({ open, onClose, title, children, footer, testId }) {
  if (!open) return null;
  return createPortal(
    <div className="modal-backdrop open" onClick={onClose} data-testid={testId || "modal-backdrop"}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <h3>{title}</h3>
          <button className="modal-close" onClick={onClose} data-testid="modal-close-btn">✕</button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-foot">{footer}</div>}
      </div>
    </div>,
    document.body
  );
}